import useApplicableFormsListService from "./service";
import TicketUpgradeCard from "../ticketUpgradeCard";
import orderBy from "lodash/orderBy";
import React from "react";
import Icon from "assets/icons";
import { useCopies } from "shared/hooks/useCopies";
import { ComposedIcons } from "assets/icons/icons.compose";

export default function ApplicableFormsList() {
  const service = useApplicableFormsListService();
  const copies = useCopies();

  return (
    <React.Fragment>
      <div className="ticketUpgrade_wrapper">
        {service.currentTicketDetails && (
          <div className="ticketUpgrade_currentWrapper">
            <div className="ticketUpgrade_currentTicket">
              <span className="ticketUpgradeToArrow">
                <Icon.ArrowUpBox />
              </span>
              <TicketUpgradeCard
                key={service.currentTicketDetails.id}
                ticketDetails={service.currentTicketDetails}
                currentTicketDetails={service.currentTicketDetails}
              />
            </div>
            {service.purchasedPrivilegesList.length > 0 && (
              <div className="ticketUpgrade_purchasedAddOnsWrapper">
                <div className="purchasedAddOnsWrapper">
                  <div className="ticketUpgradeCard_headerBorder">
                    <ComposedIcons.TicketBorder />
                  </div>
                  <div className="purchasedAddOnsWrapper_content">
                    <div className="purchasedAddOnsWrapper_title">{copies.get("upgrade.ticket.purchased.addons")}</div>

                    <div className="purchasedAddOnsWrapper_list">
                      <ul className="privilegesList_wrapper">
                        {service.purchasedPrivilegesList.map(item => (
                          <li className="privileges_item privileges_itemPurchased" key={item.id}>
                            <Icon.CheckVerified />
                            {item.label}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="ticketUpgradeCard_footerBorder">
                    <ComposedIcons.TicketBorder />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="ticketUpgrade_applicableWrapper">
          {orderBy(service.applicableFormsList, ["priceDifference.value", "title"], ["desc"]).map(item => (
            <div key={item.id} className="ticketUpgrade_applicableTicket">
              <TicketUpgradeCard
                key={item.id}
                ticketDetails={item}
                currentTicketDetails={service.currentTicketDetails}
              />
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}
